<template>
  <heat :color="getColor" class="w-100" />
</template>

<script>
import BaseIcon from '@/components/icons/mixins/BaseIcon';

export default {
  name: 'HeatWrapper',
  mixins: [
    BaseIcon,
  ],
  data() {
    return {
      turnedOffColor: '#CCCCCC',
      heatingOnColor: '#EB7087',
      coolingOnColor: '#1DAAE1',
      ventilatingOnColor: '#83C354',
    };
  },
  computed: {
    getColor() {
      if (this.isHeatingOn) {
        return this.heatingOnColor;
      }
      if (this.isCoolingOn) {
        return this.coolingOnColor;
      }
      if (this.isVentilatingOn) {
        return this.ventilatingOnColor;
      }
      return this.turnedOffColor;
    },
    isVentilatingOn() {
      return this.getVarsValue('HVAC_VENTILATE') || false;
    },
    isCoolingOn() {
      return this.getVarsValue('HVAC_COOL') || false;
    },
    isHeatingOn() {
      return this.getVarsValue('HVAC_HEAT') || false;
    },
  },
};
</script>

<style scoped>

</style>
